export const disableActionsByDefault = (columnId: string) => {
  return (
    columnId === 'cd-loja-codigo-id' ||
    columnId === 'cd-loja-tipo-id' ||
    columnId === 'gerente-categoria-id' ||
    columnId === 'gerente-produto-id' ||
    columnId === 'mundo-codigo-id' ||
    columnId === 'mundo-nome-id' ||
    columnId === 'categoria-compacta-codigo-id' ||
    columnId === 'categoria-compacta-nome-id' ||
    columnId === 'categiria-codigo-id' ||
    columnId === 'categiria-nome-id' ||
    columnId === 'status-nome-id' ||
    columnId === 'curva-abc-nome-id' ||
    columnId === 'empresa-codigo-id' ||
    columnId === 'empresa-nome-id' ||
    columnId === 'valor-estoque-atual-id' ||
    columnId === 'valor-estoque-transito-id' ||
    columnId === 'valor-estoque-reservado-id' ||
    columnId === 'valor-estoque-excesso-id' ||
    columnId === 'valor-estoque-falta-id' ||
    columnId === 'ruptura-num-sku-id' ||
    columnId === 'ruptura-porcentagem-id'
  )
}
